import { LayoutElement } from '../../../types/models/Elements';
import { panoramicLayouts4Photos } from '../panoramic/4photos';

export const mugLayouts4Photos: LayoutElement[][] = [
  ...panoramicLayouts4Photos,
];
